import React, { FormEvent, useState } from "react";

import api from "../../services/api";
import Input from "../../components/Input";
import PageHeader from "../../components/PageHeader";
import Select from "../../components/Select";
import TeacherItem, { Teacher } from "../../components/TeacherItem";
import "./styles.css";

function TeacherList() {
	const [teachers, setTeachers] = useState([]);

	const [subject, setSubject] = useState("");
	const [week_day, setWeekDay] = useState("");
	const [time, setTime] = useState("");

	function searchTeachers(event: FormEvent) {
		event.preventDefault();

		api
			.get("/classes", {
				params: {
					subject,
					week_day,
					time,
				},
			})
			.then((response) => {
				setTeachers(response.data)
			});
	}

	return (
		<div id="page-teacher-list" className="container">
			<PageHeader title="Estes são os proffys disponíveis.">
				<form id="search-teachers" onSubmit={searchTeachers}>
					<Select
						name="subject"
						label="Matéria"
						options={[
							{ value: "Artes", label: "Artes" },
							{ value: "Biologia", label: "Biologia" },
							{ value: "Ciências", label: "Ciências" },
							{ value: "Educação Física", label: "Educação Física" },
							{ value: "Física", label: "Física" },
							{ value: "Geografia", label: "Geografia" },
							{ value: "História", label: "História" },
							{ value: "Matemática", label: "Matemática" },
							{ value: "Português", label: "Português" },
							{ value: "Química", label: "Química" },
						]}
						value={subject}
						onChange={(event) => setSubject(event.target.value)}
					/>

					<Select
						name="week_day"
						label="Dia da semana"
						options={[
							{ value: "0", label: "Domingo" },
							{ value: "1", label: "Segunda-feira" },
							{ value: "2", label: "Terça-feira" },
							{ value: "3", label: "Quarta-feira" },
							{ value: "4", label: "Quinta-feira" },
							{ value: "5", label: "Sexta-feira" },
							{ value: "6", label: "Sábado" },
						]}
						value={week_day}
						onChange={(event) => setWeekDay(event.target.value)}
					/>

					<Input
						name="time"
						label="Hora"
						type="time"
						value={time}
						onChange={(event) => setTime(event.target.value)}
					/>

					<button>Buscar</button>
				</form>
			</PageHeader>

			<main>
				{teachers.map((teacher: Teacher) => (
					<TeacherItem key={teacher.id} teacher={teacher} />
				))}
			</main>
		</div>
	);
}

export default TeacherList;
